import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Title = styled.h1`
	text-align: center;
	margin-top: 20px;
	font-size: 28px;
	line-height: 35px;
	margin-bottom: 5px;
	max-width: 250px;
	font-family: 'Poppins', sans-serif;
	font-weight: 500;
	align-self: center;
	color: #141414;
`;

export const Paragraph = styled(Typography.Paragraph)`
	text-align: center;
	margin-bottom: 20px;
	color: #141414;
	font-size: 1rem;
	line-height: 120%;
`;

export const StyledLink = styled(Link)`
	font-weight: 700;
	font-size: 15px;
	text-decoration: none;
	color: #2875ea;

	&:hover {
		text-decoration: underline;
	}
`;

export const LinkContainer = styled.div`
	margin-top: 12px;
	font-size: 14px;
	font-weight: 500;
	text-align: center;
	color: #595959;
`;

export const MissingPasswordLink = styled(Link)`
	font-family: 'Inter';
	font-weight: 500;
	font-size: 13px;
	line-height: 15px;
	width: 100%;
	display: inline-block;
	text-align: right;
	color: #595959;
	margin-top: 5px;
`;

export const LogoWrapper = styled.div`
	text-align: center;
`;
